export default __webpack_public_path__ + "static/media/Tinos-Italic.0e08e8bd.ttf";